import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { getProductLineIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../constants/BusinessObjectivesTranslationKeys';
import SuiteBusinessObjectivesSubtext from '../merch-card/business-objectives/SuiteBusinessObjectivesSubtext';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
const StyledP = styled.p.withConfig({
  displayName: "MobileSuiteBusinessObjectives__StyledP",
  componentId: "xp42um-0"
})(["height:", ";"], ({
  addSpacing
}) => addSpacing ? '17px' : '0');

const MobileSuiteBusinessObjectives = ({
  productLevel,
  addSpacing = false
}) => {
  const DisplayedProductLines = AllCombinedProductLines;
  const ProductIcons = getProductLineIcons();
  return /*#__PURE__*/_jsxs(UIAccordionItem, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.businessObjectives.seeDetails"
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: "p-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), DisplayedProductLines.map(localProductLine => {
      return /*#__PURE__*/_jsxs(UIFlex, {
        className: "m-y-1",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-right-3",
          src: ProductIcons[localProductLine],
          style: {
            height: '35px'
          }
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
          }), /*#__PURE__*/_jsx(StyledP, {
            addSpacing: addSpacing,
            children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
              productLevel: productLevel,
              productLine: localProductLine
            })
          })]
        })]
      }, localProductLine);
    })]
  });
};

export default MobileSuiteBusinessObjectives;